import {
  DntEventsListState,
} from '@deltager/organizers/admin/modules/events/events-list-main/dnt-events-list/store/dnt-events-list.state';
import { Action } from '@ngrx/store';
import {
  CoreFiltersChangedAction,
  DntEventsListActionTypes, ExportableTableConfigsChangedAction, ExportReportRequestedAction, LoadingChangedAction,
} from '@deltager/organizers/admin/modules/events/events-list-main/dnt-events-list/store/dnt-events-list.actions';

export const dntEventsListReducer = (
  state: DntEventsListState = {} as DntEventsListState,
  action: Action
): DntEventsListState => {
  switch (action.type) {
    case DntEventsListActionTypes.ExportableTableConfigsChanged: {
      return Object.assign({}, state, {
        tableConfig: (action as ExportableTableConfigsChangedAction).payload
      } as DntEventsListState);
    }
    case DntEventsListActionTypes.LoadingChanged: {
      return Object.assign({}, state, {
        isLoading: (action as LoadingChangedAction).payload
      } as DntEventsListState);
    }

    case DntEventsListActionTypes.CoreFiltersChanged: {
      return Object.assign({}, state, {
        coreFilters: (action as CoreFiltersChangedAction).payload
      } as DntEventsListState);
    }
    case DntEventsListActionTypes.ExportReportRequested: {
      return Object.assign({}, state, {
        exportMetadata: (action as ExportReportRequestedAction).payload
      } as DntEventsListState);
    }
    default:
      return state;
  }
};
